'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { stringify as stringifyQuery } from 'hub-http/helpers/params';
export default class ReturnLink extends Component {
  render() {
    const {
      query
    } = this.props;
    return /*#__PURE__*/_jsx(Link, {
      to: {
        pathname: '/',
        search: `?${stringifyQuery(query)}`
      },
      children: "hubspot.com/login"
    });
  }

}
ReturnLink.propTypes = {
  query: PropTypes.object
};